import React, { useContext } from 'react';
import { Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';

import LanguagesContext from 'src/context/languages.jsx';
import ModalsContext from 'src/context/modals.jsx';

const EventsTable = ({ fields, remove, update }) => {
	if (!fields?.length) return <></>;

	const modals_context = useContext(ModalsContext);
	const { def_lang } = useContext(LanguagesContext);

	return (
		<Grid item xs={12}>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ pl: 3 }}>Name</TableCell>
							<TableCell align="left">Description</TableCell>
							<TableCell align="right">Date</TableCell>
							<TableCell align="left">Position</TableCell>
							<TableCell align="right" sx={{ pr: 3 }}>
								Actions
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{fields.map(({ header, desc, date, line }, index) => (
							<TableRow key={index}>
								<TableCell sx={{ pl: 3 }}>
									<Typography align="left" variant="subtitle1" noWrap>
										{header[def_lang]}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{desc[def_lang]}
									</Typography>
								</TableCell>

								<TableCell align="right">{date}</TableCell>
								<TableCell align="left">{line}</TableCell>

								<TableCell sx={{ pr: 1 }} align="right">
									<Stack direction="row">
										<IconButton
											color="secondary"
											size="large"
											onClick={() =>
												modals_context.show('section_event_edit', {
													data: fields[index],
													clb: (data) => update(index, data),
												})
											}
										>
											<EditTwoToneIcon sx={{ fontSize: '1.3rem' }} />
										</IconButton>

										<IconButton
											color="error"
											size="small"
											onClick={() =>
												modals_context.show('item_delete', {
													clb: () => remove(index),
												})
											}
										>
											<DeleteTwoToneIcon fontSize="small" />
										</IconButton>
									</Stack>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Grid>
	);
};

export default EventsTable;
